// The ticket page keeps the ticket it was given in this browser tab, so a
// refresh shows it again. A guest's sign-in is forgotten as soon as the
// ticket first shows, so asking the engine again would be refused and the
// page would stay empty. sessionStorage ends when the tab is closed.
const PREFIX = "ticket:";

export const saveTicket = (bookingId, ticket) => {
  if (!bookingId || !ticket) return;
  try {
    window.sessionStorage.setItem(PREFIX + bookingId, JSON.stringify(ticket));
  } catch (e) {
    // Storage blocked or full: a refresh asks the engine, as before.
  }
};

export const readSavedTicket = (bookingId) => {
  if (!bookingId) return null;
  try {
    const saved = window.sessionStorage.getItem(PREFIX + bookingId);
    const ticket = saved ? JSON.parse(saved) : null;
    return ticket && typeof ticket === "object" ? ticket : null;
  } catch (e) {
    return null;
  }
};
